/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current state of the meet login.

- `active`: Login is healthy and can be assigned to bots
- `invalid`: System auto-flipped this on bot login failure (suspended user, first-time interactive login required, etc.). Manual re-enable required.
 */
export type ListMeetLogins200DataItemState =
  (typeof ListMeetLogins200DataItemState)[keyof typeof ListMeetLogins200DataItemState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListMeetLogins200DataItemState = {
  active: "active",
  invalid: "invalid"
} as const
